import { CHEAT_ENABLED } from "../env/appFlavor.js";
import type { GpgsPort } from "@yjsgames/gpgs-ports";

/**
 * dev/치트 빌드 — 브라우저/네이티브 콘솔 + AutoPlay 스크립트용 GPGS 디버그 글로벌 설치
 * (`installDiagGlobal`의 `window.__diag` 패턴과 동형). GameApi 계약(동결)을 건드리지 않고 GPGS를
 * 런타임 검증하는 경로. 라이브 빌드는 CHEAT_ENABLED=false라 미설치(번들 영향 0).
 *
 * 사용(dev 콘솔/AutoPlay):
 *  - `await window.__gpgs.signIn()`       → 로그인 트리거 + 결과
 *  - `window.__gpgs.dump()`               → isAvailable 등 현재 상태
 *  - `await window.__gpgs.serverAuthCode()`→ Phase 2 server auth code(미발급 strings면 실패→null)
 *
 * port는 getter 주입 — 네이티브 어댑터가 dynamic import로 교체돼도 항상 최신 포트를 호출.
 */
export function installGpgsDebugGlobal(port: () => GpgsPort): void {
  if (!CHEAT_ENABLED || typeof window === "undefined") return;
  (window as unknown as Record<string, unknown>)["__gpgs"] = {
    signIn: () => port().signIn(),
    dump: () => ({ isAvailable: port().isAvailable() }),
    serverAuthCode: () => port().getServerAuthCode(),
    unlock: (achievementId: string) => port().unlockAchievement(achievementId),
    submitScore: (leaderboardId: string, score: number) =>
      port().submitLeaderboardScore(leaderboardId, score),
  };
}
